'use client';

import React, { useEffect, useState } from 'react';
import { YMaps } from '@pbe/react-yandex-maps';
import { QueryClientProvider, QueryClient } from '@tanstack/react-query';
import { Observer } from 'tailwindcss-intersect';

export const Providers: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [client] = useState(new QueryClient());

  useEffect(() => {
    Observer.start();
  }, []);

  return (
    <QueryClientProvider client={client}>
      <YMaps>{children}</YMaps>
    </QueryClientProvider>
  );
};
